import { Link } from "react-router-dom";

import { Disclosure, Menu } from "@headlessui/react";
import { MenuIcon, XIcon } from "@heroicons/react/outline";

import { useUser } from "@ip-contexts/user-context";
import { publicPath } from "@ip-utils";

export default function Navbar({ setSidebarOpen }: any) {
  const {
    state: { user },
  } = useUser();
  const { name = "" } = user;

  return (
    <Disclosure as="nav" className="bg-gray-800">
      {({ open }) => (
        <>
          <div className="max-w sm:px-4 lg:px-6">
            <div className="relative flex items-center justify-between h-16">
              <div
                className="absolute inset-y-0 left-0 flex items-center sm:hidden"
                onClick={setSidebarOpen}
              >
                <Disclosure.Button className="inline-flex items-center justify-center p-2 text-gray-400 rounded-md hover:bg-gray-700 hover:text-white focus:outline-none focus:ring-2 focus:ring-inset focus:ring-white">
                  <span className="sr-only">Open main menu</span>
                  {open ? (
                    <XIcon className="block w-6 h-6" aria-hidden="true" />
                  ) : (
                    <MenuIcon className="block w-6 h-6" aria-hidden="true" />
                  )}
                </Disclosure.Button>
              </div>
              <div className="flex items-center justify-center flex-1 sm:items-stretch sm:justify-start">
                <div className="flex items-center flex-shrink-0">
                  <Link to="/">
                    <img
                      className="w-auto h-9"
                      src={publicPath("/media/iglu-white.svg")}
                      alt="iglu"
                    />
                  </Link>
                </div>
              </div>
              <div className="absolute inset-y-0 right-0 flex items-center pr-2 sm:static sm:inset-auto sm:ml-6 sm:pr-0">
                <Menu as="div" className="relative ml-3">
                  <div>
                    <Menu.Button className="flex text-sm bg-gray-800 rounded-full">
                      <span className="sr-only">Open user menu</span>
                      <span className="inline-flex items-center justify-center w-8 h-8 bg-gray-500 rounded-full">
                        <span className="font-medium leading-none text-white text-md">
                          {name[0]?.toUpperCase()}
                        </span>
                      </span>
                    </Menu.Button>
                  </div>
                </Menu>
              </div>
            </div>
          </div>
        </>
      )}
    </Disclosure>
  );
}
